// extracted by mini-css-extract-plugin
module.exports = {"topbarforapplicationContainer":"TopbarForApplication_topbarforapplicationContainer__2hSHR"};